<div class="dialog-container">
    <div class="dialog-header">
        <div class="header-icon">
            <mat-icon>local_shipping</mat-icon>
        </div>
        <div class="header-content">
            <h2 class="dialog-title">Assign Trucks</h2>
            <p class="dialog-subtitle">Select trucks to assign to this booking</p>
        </div>
    </div>

    <div class="dialog-body">
        <!-- Search box -->
        <div class="search-wrapper">
            <mat-icon class="search-icon">search</mat-icon>
            <input
                type="text"
                class="search-input"
                [(ngModel)]="searchText"
                placeholder="Search truck..."
            />
            <mat-icon *ngIf="searchText" class="clear-icon" (click)="searchText = ''">close</mat-icon>
        </div>

        <!-- Truck type filter chips -->
        <div class="filter-bar" *ngIf="sortedTruckTypes.length > 1">
            <button class="filter-chip" [class.active]="selectedTypeFilter === null" (click)="setTypeFilter(null)">All</button>
            <button
                *ngFor="let type of sortedTruckTypes"
                class="filter-chip"
                [class.active]="selectedTypeFilter === type"
                (click)="setTypeFilter(type)">
                {{ type }}
            </button>
        </div>

        <!-- Selection limit hint -->
        <div class="limit-hint" *ngIf="maxSelectable < 999">
            <mat-icon>info</mat-icon>
            <span>Select up to <strong>{{ maxSelectable }}</strong> truck(s) — {{ maxSelectable - selectedTruckIds.length }} remaining</span>
        </div>

        <!-- Truck list -->
        <div class="truck-list-container">
            <ng-container *ngFor="let group of groupedTrucks">
                <div class="truck-type-header">
                    <mat-icon class="type-header-icon">local_shipping</mat-icon>
                    <span>{{ group.type }}</span>
                </div>
                <div
                    *ngFor="let truck of group.trucks"
                    class="truck-option"
                    [class.selected]="isSelected(truck.id)"
                    [class.option-disabled]="isDisabled(truck.id)"
                    [title]="isUndersized(truck) ? 'Truck capacity is below the minimum required for this booking' : ''"
                    (click)="toggleTruck(truck.id)"
                >
                    <div class="truck-item">
                        <mat-icon class="truck-icon">local_shipping</mat-icon>
                        <span class="truck-name">{{ truck.name }}</span>
                    </div>
                    <div class="truck-checkbox" [class.checked]="isSelected(truck.id)">
                        <mat-icon *ngIf="isSelected(truck.id)">check</mat-icon>
                    </div>
                </div>
            </ng-container>

            <div *ngIf="totalFilteredCount === 0" class="empty-message">
                <mat-icon>search_off</mat-icon>
                <p>No trucks found</p>
            </div>
        </div>

        <div class="selected-count" *ngIf="selectedTruckIds.length > 0">
            <mat-icon>check_circle</mat-icon>
            <span>{{ selectedTruckIds.length }} / {{ maxSelectable }} truck(s) selected</span>
        </div>
    </div>

    <div class="dialog-actions">
        <button class="btn-cancel" (click)="onCancel()">
            Cancel
        </button>
        <button class="btn-primary" (click)="onConfirm()" [disabled]="selectedTruckIds.length === 0">
            <mat-icon>check</mat-icon>
            <span>Assign Selected</span>
        </button>
    </div>
</div>
